// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignUpForm_formContainer__C\\+s7d {
  height: 100%;
  width: 100%;
  background-color: white;  
  background-repeat: no-repeat;
  background-position: bottom;
  padding: 6% 0;
}
@media (max-width: 767px) {
  .SignUpForm_formContainer__C\\+s7d {
    padding: 0 5%;
  }
}
 .SignUpForm_headerTitle__m\\+7jS {
    margin: 15px 0 20px 0;
    color: #3F4C52 !important;
    font-family: "DM Serif Display";
    font-weight: 700;
    font-size: 2.5em;
    white-space: nowrap;
    text-align: center;
  }
.SignUpForm_input__WeSZE {
  width: 100%;
  padding: 0.5rem;
  margin: 0.1em;
  text-overflow: ellipsis;
  border: 2px solid #ccc;
  border-radius: 50em !important;
  font-size: 100%;
  transition: border-color 0.3s;
  color: inherit;
  font-family: inherit;
  line-height: inherit;

}

.SignUpForm_input__WeSZE:focus {
  outline: none;
  border-color: #D4AA41 !important;
  box-shadow: 0 0 5px rgba(212, 170, 65, 0.5) !important;
}

.SignUpForm_buttonStyle__h4iq8 {
  width: 100%; 
  max-width: 60%;
  border-radius: 50em !important;
  border-color: #D4AA41;
  padding: 0.5rem 0.5rem;
  font-size: 1em !important;
  font-weight: 600;
  background-color: #4AAE9B !important; 
  color: #fff !important;
  transition: background-color 0.3s;
}
.SignUpForm_buttonBackStyle__gMV9B {
  width: 100%; 
  max-width: 60%;
  border-radius: 50em !important;
  border-color: #D4AA41;
  padding: 0.5rem 0.5rem;
  font-size: 1em !important;
  font-weight: 600;
  background-color: #4AAE9B !important; 
  color: #fff !important;
  transition: background-color 0.3s;
}

.SignUpForm_horizontalBarContainer__oqjXX {
  display: flex;
  align-items: center;
  margin-bottom: 20px; 
}

.SignUpForm_horizontalBar__zveDY {
  flex-grow: 1;
  height: 2px;
  background-color: #000;
  margin: 0 10px;
}

.SignUpForm_inputWithIcon__D2q7C {
  position: relative;
}

.SignUpForm_icon__Yj2Wl {
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

.SignUpForm_invalidInput__1wLNI{
  border-color: red !important;
}

.SignUpForm_asterisk__bcsDS {
  color: red;
  margin-left: 4px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/SignUp/SignUpForm.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;CACC;IACG,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,oBAAoB;;AAEtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".formContainer {\n  height: 100%;\n  width: 100%;\n  background-color: white;  \n  background-repeat: no-repeat;\n  background-position: bottom;\n  padding: 6% 0;\n}\n@media (max-width: 767px) {\n  .formContainer {\n    padding: 0 5%;\n  }\n}\n .headerTitle {\n    margin: 15px 0 20px 0;\n    color: #3F4C52 !important;\n    font-family: \"DM Serif Display\";\n    font-weight: 700;\n    font-size: 2.5em;\n    white-space: nowrap;\n    text-align: center;\n  }\n.input {\n  width: 100%;\n  padding: 0.5rem;\n  margin: 0.1em;\n  text-overflow: ellipsis;\n  border: 2px solid #ccc;\n  border-radius: 50em !important;\n  font-size: 100%;\n  transition: border-color 0.3s;\n  color: inherit;\n  font-family: inherit;\n  line-height: inherit;\n\n}\n\n.input:focus {\n  outline: none;\n  border-color: #D4AA41 !important;\n  box-shadow: 0 0 5px rgba(212, 170, 65, 0.5) !important;\n}\n\n.buttonStyle {\n  width: 100%; \n  max-width: 60%;\n  border-radius: 50em !important;\n  border-color: #D4AA41;\n  padding: 0.5rem 0.5rem;\n  font-size: 1em !important;\n  font-weight: 600;\n  background-color: #4AAE9B !important; \n  color: #fff !important;\n  transition: background-color 0.3s;\n}\n.buttonBackStyle {\n  width: 100%; \n  max-width: 60%;\n  border-radius: 50em !important;\n  border-color: #D4AA41;\n  padding: 0.5rem 0.5rem;\n  font-size: 1em !important;\n  font-weight: 600;\n  background-color: #4AAE9B !important; \n  color: #fff !important;\n  transition: background-color 0.3s;\n}\n\n.horizontalBarContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px; \n}\n\n.horizontalBar {\n  flex-grow: 1;\n  height: 2px;\n  background-color: #000;\n  margin: 0 10px;\n}\n\n.inputWithIcon {\n  position: relative;\n}\n\n.icon {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.invalidInput{\n  border-color: red !important;\n}\n\n.asterisk {\n  color: red;\n  margin-left: 4px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `SignUpForm_formContainer__C+s7d`,
	"headerTitle": `SignUpForm_headerTitle__m+7jS`,
	"input": `SignUpForm_input__WeSZE`,
	"buttonStyle": `SignUpForm_buttonStyle__h4iq8`,
	"buttonBackStyle": `SignUpForm_buttonBackStyle__gMV9B`,
	"horizontalBarContainer": `SignUpForm_horizontalBarContainer__oqjXX`,
	"horizontalBar": `SignUpForm_horizontalBar__zveDY`,
	"inputWithIcon": `SignUpForm_inputWithIcon__D2q7C`,
	"icon": `SignUpForm_icon__Yj2Wl`,
	"invalidInput": `SignUpForm_invalidInput__1wLNI`,
	"asterisk": `SignUpForm_asterisk__bcsDS`
};
export default ___CSS_LOADER_EXPORT___;
